import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {updateStepsStahltreppe,
        selectStahltreppenHeight
        } from '../../../../store/actions/stahltreppen';
import TextField from '@material-ui/core/TextField';



const Step_3 = (props) => {
    const [product_height, updateProductHeight] = useState('');
    const [product_stufen, updateProductStufen] = useState(0);


   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
        const {height, stufen} = props.data.geschosshoehe[0];

        updateProductHeight(height);
        updateProductStufen(stufen);

        //update steps
        props.updateSteps(1);

        if(product_height > 0 || props.data.allVisitedSteps) {
            props.updateSteps(2);
            props.setUpdateButtonActiveStepToFalse();
        } else {
            props.setUpdateButtonActiveStepToTrue()
        }

   }

   const selectStahltreppenHeight = ev => {
       let height = ev.target.value;
       props.selectStahltreppenHeight(height);
       updateItems();
   }


    return (
        <div className="step_wrapper">
            <h2 className='step_header'>Geschosshöhe der Stahltreppe</h2>
              <div className="step_icon_wrapper">
                <div className="inner_textfield_wrapper">
                    <TextField
                        className="textfield"
                        label="Bitte wählen (in cm)"
                        type="number"
                        rowsMax={1}
                        value={product_height}
                        onChange={selectStahltreppenHeight}
                    >
                    </TextField>
                    {product_stufen>0?<span>Stufen: {product_stufen} St.</span>:''}
                </div>

            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        data: state.stahltreppenReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateSteps: ev => dispatch(updateStepsStahltreppe(ev)),
      selectStahltreppenHeight: ev => dispatch(selectStahltreppenHeight(ev))

   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_3);
